<template>
    <div class="makeMoney" v-cloak>
        <mt-loadmore :top-method="loadTop" ref="loadmore">

        <div class="bgBox"><img src="./../../../assets/home/other-bg-op.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home" tag="i"> <img src="./../../../assets/home/back.jpg" alt=""> </router-link>
            <span>快速赚钱</span>
        </div>
        <div class="makeMoneyBox">
            <p class="makeMoneyTitle">快速赚钱</p>
            <p class="makeMoneyText">下载应用－打开试玩－领取现金</p>
        </div>
        <!--高额任务-->
        <div class="play unplay" ref="zhucediv">
            <div class="playTitle unPlayTitle">
                <div class="circle"></div>
                <p class="now">高额任务&nbsp;&nbsp;|&nbsp;&nbsp;</p>
                <div class="spanBox">
                    <span class="out" style="color:#B27010; font-size: 12px;"> 总计<span class="in" style="color:#B27010; font-size: 12px;">{{task_high_total}}</span>元 </span>
                </div>
            </div>
            <div class="itemBox" 
                v-for="item in task_high"
                :key="item.id" 
                @click="sendData($event,3)">
                <div class="imgBox"><img style=" " :src="item.icon" alt=""></div>
                <div class="item">
                    <p class="itemTitle">{{item.name}}</p>
                    <p class="itemText">剩余{{item.amount}}份</p>
                        <p class="tags">{{item.start_time_n}}</p>
                </div>
                <div class="spanBox">
                    <span class='out'>＋<span class='in'>{{item.price}}</span>元</span>
                </div>
                <span class="hidden">{{item.id}}</span>
                <span class="hidden">{{item.type}}</span>
                <span class="hidden">{{item.notice}}</span>
            </div>

        </div>
        <div class="play">
            <div class="playTitle" style="background:#F7F9FD">
                <div class="circle"></div>
                <p class="now">当前试玩&nbsp;&nbsp;|&nbsp;&nbsp;</p>
                <div class="spanBox">
                    <span class="out"> 总计 <span class="in">{{task_ing_total}}</span> 元 </span>
                </div>
            </div>
            <div class="itemBox"
                v-for="item in task_ing"
                :key="item.id"
                @click="sendData($event,1)"
                >
                    <div class="imgBox"><img style=" filter: blur(5px)" :src="item.icon" alt=""></div>
                    <div class="item">
                        <p class="itemTitle" ref="itemName">{{item.name}}</p>
                        <p class="itemText">剩余{{item.amount}}份</p>
                        <p class="tags" :style="{ 'color' : item.tags=='回调' ? 'red' : ''}">{{item.tags}}</p>
                    </div>
                    <div class="spanBox">
                        <span class='out'>＋<span class='in' ref="itemPrice">{{item.price}}</span>元</span>
                    </div>
                    <span class="hidden">{{item.id}}</span>
                    <span class="hidden">{{item.bundleid}}</span>
            </div>
            <!--
             -->
            <div class="itemBox"
                v-for="item in task_back"
                :key="item.id"
                @click="sendData($event,2)"
                >
                    <div class="imgBox"><img style=" filter: blur(5px)" :src="item.icon" alt=""></div>
                    <div class="item">
                        <p class="itemTitle" ref="itemName">{{item.name}}</p>
                        <p class="tags" :style="{ 'color' : item.tags=='回调' ? 'red' : ''}">回签</p>
                    </div>
                    <div class="spanBox">
                        <span class='out'>＋<span class='in' ref="itemPrice">{{item.income}}</span>元</span>
                    </div>
                    <span class="hidden">{{item.id}}</span>
            </div>
            
            <div class="itemBox"
                v-for="item in task_high_back"
                :key="item.id"
                @click="sendData($event,4)"
                >
                    <div class="imgBox"><img style=" filter: blur(5px)" :src="item.icon" alt=""></div>
                    <div class="item">
                        <p class="itemTitle" ref="itemName">{{item.name}}</p>
                        <p class="tags" :style="{ 'color' : item.tags=='回调' ? 'red' : ''}">回签</p>
                    </div>
                    <div class="spanBox">
                        <span class='out'>＋<span class='in' ref="itemPrice">{{item.income}}</span>元</span>
                    </div>
                    <span class="hidden">{{item.id}}</span>
            </div>
        </div> 
        <div class="play unplay">
            <div class="playTitle unPlayTitle">
                <div class="circle"></div>
                <p class="now">未开始的&nbsp;&nbsp;|&nbsp;&nbsp;</p>
                <div class="spanBox">
                    <span class="out" style="color:#B27010; font-size: 12px;"> 总计<span class="in" style="color:#B27010; font-size: 12px;">{{task_coming_total}}</span>元 </span>
                </div>
            </div>
            <div class="itemBox" 
                v-for="item in task_coming"
                :key="item.id">
                <div class="imgBox"><img style=" filter: blur(5px) " :src="item.icon" alt=""></div>
                <div class="item">
                    <p class="itemTitle">{{item.name}}</p>
                    <p class="itemText">剩余{{item.amount}}份</p>
                        <p class="tags">{{item.start_time_n}}</p>
                </div>
                <div class="spanBox">
                    <span class='out'>＋<span class='in'>{{item.price}}</span>元</span>
                </div>
            </div>
        </div>
        <div class="play unplay">
            <div class="playTitle unPlayTitle">
                <div class="circle"></div>
                <p class="now">已下载的&nbsp;&nbsp;|&nbsp;&nbsp;</p>
                <div class="spanBox">
                    <span class="out" style="color:#B27010; font-size: 12px;"> 总计<span class="in" style="color:#B27010; font-size: 12px;">{{my_task_total}}</span>元 </span>
                </div>
            </div>
            <InfiniteScroll></InfiniteScroll>
        </div>
        </mt-loadmore>
    </div>


 <div data-v-f17795d6="" class="showsz" ref="showsz" style=""><h2 style="
    text-align: center;
    margin-top: 10px;
">提示</h2>
    
    <div class="ysnr" ref="ysnr" style="
    padding: 10px;
">需要在设置-隐私-追踪-开启[允许App请求跟踪]，关闭后重新打开本应用</div>
    <div style="
    border-top: 1px solid #eee;
    margin-top: 10px;
">

<div data-v-f17795d6="" class="showszqr" style="
   
"  @click="ygosq">我已授权</div>
    <div data-v-f17795d6="" class="showszqx" style="
    
"  @click="gosq">去授权</div>

</div></div>
    </div>
</template>

<script>
import axios from 'axios'
import {Toast} from 'mint-ui';
import InfiniteScroll from "./InfiniteScroll.vue"

            var isrepeat = 0;
localStorage.setItem("Date", false)


export default {
    components:{
        InfiniteScroll,
    },
    data(){
        return{
            task_ing:[],
            task_ing_total:null,
            task_back:[],
            task_high_back:[],
            task_back_total:null,
            task_coming:[],
            task_coming_total:null,
            task_high:[],
            task_high_total:null,
            my_task:[],
            my_task_total:null,
            toast:null,
        }
    },
    methods:{
        loadTop() {
            this.$refs.loadmore.onTopLoaded();
            location.reload()
        },
        
        sendData($event,type){
                console.log($event);

                if(isrepeat == 0){
                }
            let qingnum = 0;
            let _this = this
            let _event = event;
            let globletargetTaskID = 0;

            if(type == 2){
            let toast = Toast({
                message: '加载中',
                iconClass: 'fa fa-spinner fa-spin',
                duration: 5000
                });
                sendeventback(event)
            }else if(type==3){
                sendeventhigh(event)
            }else if(type==4){
            let toast = Toast({
                message: '加载中',
                iconClass: 'fa fa-spinner fa-spin',
                duration: 5000
                });
                sendeventhighback(event)
            }else{
                sendevent(event)
            }
            

            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }       
                if (window.WVJBCallbacks) {
                    return window.WVJBCallbacks.push(callback); 
                }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }
            function sendeventhigh(_event){
                let typetext=_event.currentTarget.children[5].innerHTML;
                let type=_event.currentTarget.children[4].innerHTML;
		if(type == '4'){
			if(!confirm(typetext)){
				return false;
			}
		}
            let toast = Toast({
                message: '加载中',
                iconClass: 'fa fa-spinner fa-spin',
                duration: 5000
                });
                let targetTaskID=_event.currentTarget.children[3].innerHTML;

                setupWebViewJavascriptBridge(function(bridge) { 
                    bridge.callHandler('checkDeviceChargeState', function(response) { 
                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"),
                            udid : localStorage.getItem("UDID"),
                            ip : localStorage.getItem("IP"),
                            device : localStorage.getItem("DEVICE"),
                            token : localStorage.getItem("UserToken"),
                            os : localStorage.getItem("OS"),
                            task_id : targetTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/starttaskhigh", {   //发送请求给后端传加密后的数据
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{     //获得后端返回加密后的任务列表
                                if(res.data.msg == '页面超时，请返回首页'){
                                                toast.close();
                                    alert(res.data.msg);
                                    _this.$router.push({path:"/home"})
                                    return;
                                }
                                    console.log('回签返回值11')
                                    console.log(res)
                                    console.log(res.data.status)
                                if(res.data.status === 0){   
                                    
                                    alert(res.data.msg);
                                    toast.close();  
                                        
                                        if(res.data.msg=='请先绑定手机'||res.data.msg=='请先绑定微信'||res.data.msg=='请先进行设备校验'){
                                             _this.$router.push({ path:"/home/usercenter/userinfo"});
                                        }
                                    return;
                                }else{   //任务请求可以进入任务的时候
                                    if(res.data.status === 2){ 
                                        alert(res.data.msg);
                                    }
                                    var data = {
                                                continueUserTaskid:res.data.data.id,
                                                continueSrc : res.data.data.icon,
                                                continueTitle : res.data.data.name,
                                                continuePrice : res.data.data.income,
                                                continueMinute : res.data.data.limit_time,
                                                continueSecond : 0,
                                                continueAppurl: res.data.data.appurl,
                                                continueKeyword: res.data.data.keyword,
                                                continueContent : res.data.data.tpl_content,   
                                                continuePlaytime : 30,
                                                continueRank : 1,     
                                                continueTaskID : res.data.data.usertaskid,
                                                continueBundleID : res.data.data.bundleid
                                            };
                                    console.log('高额任务')
                                    console.log(data)
                                   _this.$router.push({
                                            path:"/home/makemoney/taskhigh",
                                            query:data
                                        })

                                }
                                     toast.close();
                                    })
                            })
                        })
                    })
            }
            function sendeventhighback(_event){

                let targetTaskID=_event.currentTarget.children[3].innerHTML;

                setupWebViewJavascriptBridge(function(bridge) { 
                    bridge.callHandler('checkDeviceChargeState', function(response) { 
                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"),
                            udid : localStorage.getItem("UDID"),
                            ip : localStorage.getItem("IP"),
                            device : localStorage.getItem("DEVICE"),
                            token : localStorage.getItem("UserToken"),
                            os : localStorage.getItem("OS"),
                            task_id : targetTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/starttaskhighback", {   //发送请求给后端传加密后的数据
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{     //获得后端返回加密后的任务列表
                                if(res.data.msg == '页面超时，请返回首页'){
                                                toast.close();
                                    alert(res.data.msg);
                                    _this.$router.push({path:"/home"})
                                    return;
                                }
                                    console.log('回签返回值11')
                                    console.log(res)
                                    console.log(res.data.status)
                                if(res.data.status === 0){   
                                    
                                    alert(res.data.msg);
                                    toast.close();  
                                    return;
                                }else{   //任务请求可以进入任务的时候
                                    var data = {
                                                continueUserTaskid:res.data.data.user_task_id,
                                                continueSrc : res.data.data.icon,
                                                continueTitle : res.data.data.name,
                                                continuePrice : res.data.data.income,
                                                continueMinute : res.data.data.limit_time,
                                                continueSecond : 0,
                                                continueAppurl: res.data.data.appurl,
                                                continueKeyword: '',
                                                continueContent : res.data.data.tpl_content,   
                                                continuePlaytime : res.data.data.playtime,
                                                continueRank : 1,     
                                                continueTaskID : res.data.data.id,
                                                continueBundleID : res.data.data.bundleid
                                            };
                                    console.log('回签返回值11')
                                    console.log(res)
                                   _this.$router.push({
                                            path:"/home/makemoney/taskhighback",
                                            query:data
                                        })

                                }
                                     toast.close();
                                    })
                            })
                        })
                    })
            }
            function sendeventback(_event){

                let targetTaskID=_event.currentTarget.children[3].innerHTML;

                setupWebViewJavascriptBridge(function(bridge) { 
                    bridge.callHandler('checkDeviceChargeState', function(response) { 
                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"),
                            udid : localStorage.getItem("UDID"),
                            ip : localStorage.getItem("IP"),
                            device : localStorage.getItem("DEVICE"),
                            token : localStorage.getItem("UserToken"),
                            os : localStorage.getItem("OS"),
                            task_id : targetTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/starttaskback", {   //发送请求给后端传加密后的数据
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{     //获得后端返回加密后的任务列表
                                if(res.data.msg == '页面超时，请返回首页'){
                                                toast.close();
                                    alert(res.data.msg);
                                    _this.$router.push({path:"/home"})
                                    return;
                                }
                                    console.log('回签返回值11')
                                    console.log(res)
                                    console.log(res.data.status)
                                if(res.data.status === 0){   
                                    
                                    alert(res.data.msg);
                                    toast.close();  
                                    return;
                                }else{   //任务请求可以进入任务的时候
                                    var data = {
                                                continueUserTaskid:res.data.data.user_task_id,
                                                continueSrc : res.data.data.icon,
                                                continueTitle : res.data.data.name,
                                                continuePrice : res.data.data.income,
                                                continueMinute : res.data.data.limit_time,
                                                continueSecond : 0,
                                                continueAppurl: res.data.data.appurl,
                                                continueKeyword: '',
                                                continueContent : res.data.data.tpl_content,   
                                                continuePlaytime : res.data.data.playtime,
                                                continueRank : 1,     
                                                continueTaskID : res.data.data.id,
                                                continueBundleID : res.data.data.bundleid
                                            };
                                    console.log('回签返回值11')
                                    console.log(res)
                                   _this.$router.push({
                                            path:"/home/makemoney/taskback",
                                            query:data
                                        })

                                }
                                     toast.close();
                                    })
                            })
                        })
                    })
            }
            function playThisApp(bundid){
            let _this = this
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }       
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)                  
            }                                                                                                    
            setupWebViewJavascriptBridge(function(bridge) {                                                  
                bridge.callHandler('openLoApplic', {
                    cn: "LSApplicationWorkspace",
                    mn: "openApplicationWithBundleID:",
                    bdid: bundid
                }, function(response) {
                    if(response.info === "notOpen") {
                    }else{
                        
                        Toast("您已下载过该app") 
                        return;
                    }                 
                })
            })
        }
            function sendevent(_event){
               // console.log(3333);
               // console.log(_event);
               // console.log(_event.currentTarget);
               // console.log(66666);
              //  console.log(typeof(_event.currentTarget));
                if(isrepeat == 1){
                return ;
                }
            let toastks = Toast({
                message: '加载中',
                iconClass: 'fa fa-spinner fa-spin',
                duration: 5000
                });
                isrepeat = 1;
                let targetTaskID = globletargetTaskID;
                let bundid = '';
                if(_event.currentTarget!=null){
                    targetTaskID=_event.currentTarget.children[3].innerHTML;
                    globletargetTaskID = targetTaskID;
                    bundid=_event.currentTarget.children[4].innerHTML;
                    
                }
                setupWebViewJavascriptBridge(function(bridge) { 
                    //判断是否在充电状态
                    bridge.callHandler('checkDeviceChargeState', function(response) { 
                    console.log(response)
                    //if(response.chargeState !=='未充电'){
                     //   alert('充电状态无法获取任务')
                     //   toast.close();
                    //}else{
			     
			//验证是否安装                             
                bridge.callHandler('openLoApplic', {
                    cn: "LSApplicationWorkspace",
                    mn: "openApplicationWithBundleID:",
                    bdid: bundid
                }, function(response) {
                    if(response.info === "notOpen") {


                                        console.log(555555);
                                    console.log(response.info)

//验证是否安装


                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"),
                            udid : localStorage.getItem("UDID"),
                            ip : localStorage.getItem("IP"),
                            device : localStorage.getItem("DEVICE"),
                            token : localStorage.getItem("UserToken"),
                            os : localStorage.getItem("OS"),
                            task_id : targetTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/starttask", {   //发送请求给后端传加密后的数据
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{     //获得后端返回加密后的任务列表
                                        console.log(2233332);
                                    console.log(res.data)
                                isrepeat = 0;
                                if(res.data.msg == '页面超时，请返回首页'){
                                                toastks.close();
                                    alert(res.data.msg);
                                    _this.$router.push({path:"/home"})
                                    return;
                                }
                                if(res.data.status === 0){   
                                    //if(res.data.msg=='超时'){
//
                                    //}
                                    if(res.data.msg=='抢任务人数过多'&&qingnum<5){
                                        //循环请求10次，
                                        qingnum++
                                        console.log(qingnum)
                                        sendevent(_event)
                                        return;
                                    }else{
                                        alert(res.data.msg);
                                        toastks.close();      
                                        if(res.data.msg=='请先绑定手机'||res.data.msg=='请先绑定微信'||res.data.msg=='请先进行设备校验'){
                                             _this.$router.push({ path:"/home/usercenter/userinfo"});
                                        }
                                        return;        
                                    }        
                                    
                                }else if(res.data.status === 1){   //任务请求可以进入任务的时候
                                    let api = "/api/task/info2?id=" + targetTaskID
                                    axios.post( api, {
                                        code : TaskCode,
                                        dataSign : TaskSign
                                    }).then(res=>{
                                        if(res.data.status === 0){
                                            toastks.close();
                                            alert(res.data.msg);
                                        }else{
                                            bridge.callHandler('decrpt', {
                                                dataReq : res.data.dataReq,
                                                dataSign : res.data.dataSign,
                                            }, function(response) { 
                                                console.log("info2任务列表点击后打印", response)
                                                _this.$router.push({
                                                    path:"/home/makemoney/task",
                                                    query:{
                                                        continueUserTaskid:response.info.data.UserTaskid,
                                                        continueSrc : response.info.data.icon,
                                                        continueTitle : response.info.data.name,
                                                        continuePrice : response.info.data.price,
                                                        continueMinute : response.info.data.limit_time,
                                                        continueSecond : 0,
                                                        continueAppurl: response.info.data.appurl,
                                                        continueKeyword: response.info.data.keyword,
                                                        continueContent : response.info.data.tpl_content,   
                                                        continuePlaytime : response.info.data.play_time,
                                                        continueRank : response.info.data.rank,     
                                                        continueTaskID : targetTaskID,
                                                        continueBundleID : response.info.data.bundleid
                                                    }
                                                })
                                                toastks.close();
                                            })
                                        }
                                    }).catch(error=>{
                                        toastks.close();
                                        if(/Network/ig.test(error)){
                                            alert("未连接网络")
                                        }else{
                                            alert(error)
                                        }
                                    })
                                }else{
                                    toastks.close();
                                    alert("请求失败，请稍后再试")
                                }
                            }).catch(error=>{
                                toastks.close();
                                if(/Network/ig.test(error)){
                                    alert("未连接网络")
                                }else{
                                    alert(error)
                                }
                            })
                        })







                    }else{	
		    	
			alert('您已经已下载该app')
			isrepeat = 0;
                          toastks.close();
             //获取到加密后的数据
                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"),
                            udid : localStorage.getItem("UDID"),
                            ip : localStorage.getItem("IP"),
                            device : localStorage.getItem("DEVICE"),
                            token : localStorage.getItem("UserToken"),
                            os : localStorage.getItem("OS"),
                            task_id : targetTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {  
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/saveopenyxz", {   //发送请求给后端传加密后的数据
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{     //获得后端返回加密后的任务列表
                                        console.log(2233332);
			
					               
				})     
			})
			//验证是否安装
                    }                 
                })
			//验证是否安装


                   // }



                })
            })
        }
        }
    },
    created(){
        let toast = Toast({
            message: '加载中',
            iconClass: 'fa fa-spinner fa-spin',
            duration: 5000,
            });
        let self = this
        function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }       
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) { 
            bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                uid : localStorage.getItem("UID"),
                idfa : localStorage.getItem("IDFA"),
                udid : localStorage.getItem("UDID"),
                ip : localStorage.getItem("IP"),
                device : localStorage.getItem("DEVICE"),
                token : localStorage.getItem("UserToken"),
                os : localStorage.getItem("OS"),
                request_time : Date.parse(new Date())
                },function(response) {               //获取到加密后的数据
                let TaskCode = response.dataReq
                let TaskSign = response.dataSign
                axios.post("/api/task/tlist", {   //发送请求给后端传加密后的数据
                    code : TaskCode,
                    dataSign : TaskSign
                }).then(res=>{     //获得后端返回加密后的任务列表
                        if(res.data.msg == '页面超时，请返回首页'){
                            alert(res.data.msg);
                            _this.$router.push({path:"/home"})
                            return;
                        }
                    bridge.callHandler('decrpt', {
                        dataReq : res.data.dataReq,
                        dataSign : res.data.dataSign,
                    }, function(response) {
                        console.log(response)
                        //调用ios解密函数decrpt，将加密任务列表解密
                        //拿到列表数据，赋值给data里的空数组，渲染。
                        toast.close();
                        self.task_coming = response.info.data.task_coming.list
                        self.task_coming_total = response.info.data.task_coming.total
                        self.task_high = response.info.data.task_high.list
                        self.task_high_total = response.info.data.task_high.total
                        console.log(self.task_high_total)
                        console.log(9988888)
                        if(self.task_high_total>0){
                            self.$refs.zhucediv.style.display = "block"
                        }else{
                            self.$refs.zhucediv.style.display = "none"
                        }
                        self.task_ing = response.info.data.task_ing.list
                        self.task_back = response.info.data.task_back.list
                        self.task_high_back = response.info.data.task_high_back.list
                        self.task_ing_total = response.info.data.task_ing.total
                        self.my_task = response.info.data.my_task.list
                        self.my_task_total = response.info.data.my_task.total
                        self.task_ing.map(item=>{
                            item.tags = item.tags.replace(/,/gi , " ")
                        })

                    })
                })
                axios.post("/api/task/mytask", {
                    code : TaskCode,
                    dataSign : TaskSign
                }).then(res=>{
                    bridge.callHandler('decrpt', {
                        dataReq : res.data.dataReq,
                        dataSign : res.data.dataSign,
                    }, function(response) {
                        console.log(9999999);
                        console.log(response.info);
                        let TaskID = 0;
                        if(response.info.status === 0){
                             TaskID = response.info.task_id
                            toast.close();
                            alert("你有正在进行中的任务")
                            bridge.callHandler('encrypt', {
                                uid : localStorage.getItem("UID"),
                                idfa : localStorage.getItem("IDFA"),
                                udid : localStorage.getItem("UDID"),
                                ip : localStorage.getItem("IP"),
                                device : localStorage.getItem("DEVICE"),
                                os : localStorage.getItem("OS"),
                                request_time : Date.parse(new Date()),
                                continue : 1,
                                task_id : TaskID,
                            }, function(response) { 
                                let continueTaskCode = response.dataReq
                                let continueTaskSign = response.dataSign
                                axios.post("/api/task/info2", {
                                    code : continueTaskCode,
                                    dataSign : continueTaskSign
                                }).then(res=>{
                                    if(res.data.status === 0){
                                        alert(res.data.msg);
                                    }else{
                                        bridge.callHandler('decrpt', {
                                            dataReq : res.data.dataReq,
                                            dataSign : res.data.dataSign,
                                        }, function(response) { 
                                            console.log("info2任务列表检测任务状态", response)
                                            self.$router.push({
                                                path:'/home/makemoney/task',
                                                query:{
                                                    continueUserTaskid:response.info.data.UserTaskid,
                                                    continueSrc : response.info.data.icon,
                                                    continueTitle : response.info.data.name,
                                                    continuePrice : response.info.data.price,
                                                    continueMinute : parseInt(response.info.data.limit_time / 60),
                                                    continueSecond : response.info.data.limit_time % 60,
                                                    continueKeyword: response.info.data.keyword,
                                                    continueAppurl: response.info.data.appurl,
                                                    continueContent : response.info.data.tpl_content,
                                                    continuePlaytime : response.info.data.play_time,
                                                    continueRank : response.info.data.rank,
                                                    continueTaskID : TaskID,
                                                    continueBundleID : response.info.data.bundleid,
                                                }
                                            })
                                        })
                                    }
                                })
                            })
                        }
                    })
                })
            })
        })
    },
    
}
</script>

<style lang="scss" scoped>


.showszqx{width: 50%;
    display: inline-block;
    height: 30px;
    text-align: center;
    border-radius: 5px;
    line-height: 40px;
    color: #076BE5;}
.showszqr{ width: 50%;
    display: inline-block;
    height: 30px;
    color: #076BE5;
    text-align: center;}
.showsz{position: absolute;
    width: 300px;
    font-size: 16px;display:none;
    top: 33%;
    background: #fff;
    height: 160px;
    border-radius: 15px;
    left: 0;
    right: 0;    margin: 0 auto;}

    .mint-loadmore{
        font-size: 20px;
    }
    .bgBox{
        width:100%;
        height:2.06rem;
        position: absolute;
        top:.60rem;
        z-index: -1;
        img{
            border-radius: 0 0 .30rem .30rem;
        }
    }
    .top{
        height:.20rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .makeMoneyBox{
        width:90%;
        height:.90rem;
        margin-left:5%;
        margin-top:.40rem;
        .makeMoneyTitle{
            font-size: .24rem;
            color: #222527;
        }
        .makeMoneyText{
            margin-top:.10rem;
            color:#B27010;
            font-size: .12rem;
        }
    }
    .play{
        width:90%;
        margin-left:5%;
        background:#FFF;
        border-radius: .10rem;
        .playTitle{
            width:100%;
            height:.45rem;
            background:#FFFAE7;
            border-radius: .10rem .10rem 0 0;
            font-size: .18rem;
            padding-left:.1rem;
            display:flex;
            align-items: center;
            .circle{
                width:.08rem;
                height:.08rem;
                border:2px solid #FFCA10;
                float:left;
                border-radius: 50%;
            }
            .now{
                margin-left:.06rem;
                float:left;
            }
            .spanBox{
                display:block;
                float:left;
                .out{
                    color:#ACACAC;
                    font-size:.14rem;
                    .in{
                        font-size: .18rem;
                        color:#F5A623;
                    }
                }
            }
        }
        .itemBox{
            width:100%;
            height:.75rem;
            display:flex;
            align-items: center;
            position:relative;
            .imgBox{
                -webkit-touch-callout:none;
                width:.65rem;
                height:.55rem;
                margin:0 0.05rem 0 .1rem;
                padding-right:.1rem;
            }
            .itemTitle{
                font-size: .16rem;
            }
            .itemText{
                font-size: .12rem;
                color:#555555;
            }
            .spanBox{
                width:1rem;
                height:.34rem;
                position:absolute;
                right:0.14rem;
                display:flex;
                align-items: center;
                .out{
                    color:red;
                    font-size: .12rem;
                    position:absolute;
                    right:0;
                    .in{
                        font-size: 0.25rem;
                    }
                }
            }
            .hidden{
                    color:red; 
                    position:fixed;
                    left:-10000px;
                }
        }
    }
    .unplay{
        margin-top:.16rem;
        .unPlayTitle{
            font-size: .12rem;
            color:#B27010;
            background:#FFFAE7;
        }
        .circle{
            background:#FFCA10;
            border:none;
        }
    }
    .tags{
        font-size: 12px;
        color : gold;
    }
    
</style>
